export const ADMIN_ROLE_MANAGEMENT_PREFIX = 'ADMIN-ROLE-MANAGEMENT-PREFIX_';

export const FETCH_ROLE_LIST = ADMIN_ROLE_MANAGEMENT_PREFIX + 'FETCH_ROLE_LIST';

export const FETCH_PERMISSION_LIST =
  ADMIN_ROLE_MANAGEMENT_PREFIX + 'FETCH_PERMISSION_LIST';

export const SEARCH_REFRESH = ADMIN_ROLE_MANAGEMENT_PREFIX + 'SEARCH_REFRESH';
